import { trim } from 'es-toolkit'

/**
 * 문자열의 앞뒤 공백과 내부의 모든 공백을 제거합니다.
 * @param value - 공백을 제거할 문자열
 * @returns 모든 공백이 제거된 문자열
 * @example
 * removeAllWhitespace('  홍 길 동  ') // '홍길동'
 * removeAllWhitespace('  12 가 3456  ') // '12가3456'
 */
export const removeAllWhitespace = (value: string): string => {
  return trim(value).replace(/\s/g, '')
}

/**
 * 문자열이 최대 길이를 초과하면 말줄임표(…)를 붙여 잘라냅니다.
 * SEO title/description처럼 길이 상한이 있는 메타 텍스트에 사용합니다.
 * @param value - 자를 문자열
 * @param maxLength - 말줄임표 포함 최대 길이
 * @example
 * truncateText('가나다라마', 3) // '가나…'
 */
export const truncateText = (value: string, maxLength: number): string => {
  if (value.length <= maxLength) return value
  return `${value.slice(0, maxLength - 1)}…`
}
